/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiListAccessibleConsensusRulesResponse,
  getCoinbaseEngUsersAccountManagementApiApiListAccessibleConsensusRulesResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiListAccessibleConsensusRulesResponse';

export type ListAccessibleConsensusRulesArgs = {
  /**
   * organization_id scopes the fan-out to one organization per call.
   */
  organizationId: string;
};

export type ListAccessibleConsensusRulesResult =
  CoinbaseEngUsersAccountManagementApiApiListAccessibleConsensusRulesResponse;

const validateListAccessibleConsensusRulesResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiListAccessibleConsensusRulesResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: ListAccessibleConsensusRulesResult data does not match contract.`,
      errors,
    );
  }
};

export const getListAccessibleConsensusRulesUrl = (
  params: ListAccessibleConsensusRulesArgs,
  {
    additionalParams,
    baseUrl,
  }: {
    additionalParams?: Record<string, unknown>;
    baseUrl?: string;
  } = {},
) => {
  const searchParams = new URLSearchParams();
  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/v1/consensus/organizations/${
    params.organizationId
  }/rules${searchParams.toString() === '' ? '' : `?${searchParams}`}`;
  return url;
};

/**
 * Fetch ListAccessibleConsensusRules
 * @Url /v1/consensus/organizations/{organization_id}/rules
 * @Auth Required
 */

export function useGetListAccessibleConsensusRules(
  params: ListAccessibleConsensusRulesArgs,
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): ListAccessibleConsensusRulesResult | undefined;

export function useGetListAccessibleConsensusRules(
  params: ListAccessibleConsensusRulesArgs,
  options?: FetchOptions,
): ListAccessibleConsensusRulesResult;

export function useGetListAccessibleConsensusRules(
  params: ListAccessibleConsensusRulesArgs,
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getListAccessibleConsensusRulesUrl(params, options);
  const data = useFetch<ListAccessibleConsensusRulesResult>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateListAccessibleConsensusRulesResult(data);
  }

  return data;
}

/**
 * Access ListAccessibleConsensusRules fetch callback
 */
export const useGetListAccessibleConsensusRulesCallback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (
      params: ListAccessibleConsensusRulesArgs,
      additionalHeaders?: Record<string, string>,
    ) => {
      const url = getListAccessibleConsensusRulesUrl(params);
      const resource = getResource<ListAccessibleConsensusRulesResult>(
        url,
        undefined,
        additionalHeaders,
      );

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateListAccessibleConsensusRulesResult(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh ListAccessibleConsensusRules without throwing to suspense
 * @Url /v1/consensus/organizations/{organization_id}/rules
 * @Auth Required
 */
export const useRefreshListAccessibleConsensusRules = (
  params: ListAccessibleConsensusRulesArgs,
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getListAccessibleConsensusRulesUrl(params);

  const { fetch } = useFetchableResource<ListAccessibleConsensusRulesResult>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove ListAccessibleConsensusRules from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /v1/consensus/organizations/{organization_id}/rules
 */
export const useClearListAccessibleConsensusRules = (params: ListAccessibleConsensusRulesArgs) => {
  const url = getListAccessibleConsensusRulesUrl(params);

  const { clear } = useFetchableResource<ListAccessibleConsensusRulesResult>(url);

  return clear;
};

export const useWithOptimisticListAccessibleConsensusRulesUpdates = (
  params: ListAccessibleConsensusRulesArgs,
) => {
  const url = getListAccessibleConsensusRulesUrl(params);

  const { optimisticUpdate } = useFetchableResource<ListAccessibleConsensusRulesResult>(url);

  return optimisticUpdate;
};
